import { FC, Fragment } from "react";
import { Stack, Typography } from "@mui/material";
import { ResourceExplorerTableAccountCell } from "@/components/pages/resource-explorer/components/resource-explorer-card/components/billing-explorer-data-grid/components/columns-renderers/ResourceExplorerTableAccountCell";
import { TypographyWithCopy } from "@/components/common/TypographyWithCopy";
import { PreviousPeriodCostCell } from "@/components/pages/resource-explorer/components/resource-explorer-card/components/billing-explorer-data-grid/components/columns-renderers/PreviousPeriodCostCell";
import { TrendCell } from "@/components/pages/resource-explorer/components/resource-explorer-card/components/billing-explorer-data-grid/components/columns-renderers/TrendCell";
import { LabelColumnCell } from "@/components/pages/resource-explorer/components/resource-explorer-card/components/billing-explorer-data-grid/components/columns-renderers/label-column/LabelColumnCell";
import { money } from "@/utils/numeral/money";

interface InternalBillingExplorerTotalCellRendererProps {
  field: string;
  value: any;
  row: any;
}

export const InternalBillingExplorerTotalCellRenderer: FC<
  InternalBillingExplorerTotalCellRendererProps
> = ({ field, value, row }) => {
  // Switch based on field name to determine which component to render
  switch (field) {
    case "field":
      // First column (label) - use LabelColumnCell
      return (
        <Stack maxWidth={300}>
          <LabelColumnCell data={row} />
        </Stack>
      );

    case "metadata.provider_account_name":
      return <ResourceExplorerTableAccountCell data={row} />;

    case "metadata.region":
      return (
        <TypographyWithCopy
          variant="body2"
          value={row.metadata?.region ?? "-"}
          maxWidth={140}
        />
      );

    case "metadata.service":
      return (
        <TypographyWithCopy
          variant="body2"
          value={row.metadata?.service ?? "-"}
          maxWidth={140}
        />
      );

    case "total_cost":
      return (
        <Typography variant="body2" align="right">
          {isNaN(value) ? "N/A" : money(value)}
        </Typography>
      );

    case "previous_period_total_cost":
      return <PreviousPeriodCostCell value={value} pr={0} />;

    case "trend":
      return <TrendCell value={value} />;

    case "monthly_forecast":
    case "quarterly_forecast":
      return (
        <Typography variant="body2" align="right">
          {value === null ? "-" : `~${money(value?.cost)}`}
        </Typography>
      );
  }

  if (typeof value === "number") {
    return <Fragment>{value.toFixed(2)}</Fragment>;
  } else if (value === null || value === undefined) {
    return <Fragment>-</Fragment>;
  } else if (typeof value === "object") {
    return <Fragment>-</Fragment>;
  }

  return <Fragment>{value}</Fragment>;
};
